export const MAIN_SET_MESSAGE = 'MAIN_SET_MESSAGE'
export const MAIN_SET_FETCHING = 'MAIN_SET_FETCHING'

export const CATEGORIES_SET_DATA = 'CATEGORIES_SET_DATA'
export const PRODUCTS_SET_DATA = 'PRODUCTS_SET_DATA'
export const SET_HELP_ICON_ROUTES = 'SET_HELP_ICON_ROUTES'



// WEBPACK FOOTER //
// ./src/store/types.js